import { streaming } from 'src_server/trpc/types';

export type GeniusPlayerUiStatusType = 'idle' | 'loading' | 'unavailable' | 'ready' | 'playbackError';

export interface GeniusSportsMessageBodyType {
    streamId?: string;
    streamType?: string;
    deliveryType?: streaming.GeniusDeliveryProtocolType | string;
    deliveryId?: string;
    geniusSportsFixtureId?: number | string;
    device?: string;
    region?: string;
    error?: unknown;
}

export interface GeniusSportsMessageDetailType {
    type: string;
    body: GeniusSportsMessageBodyType;
}

export interface GeniusLivePlayerApiType {
    player: {
        start: (data: {
            url?: string;
            token?: string;
            expiresAt?: string;
            drm?: streaming.GeniusDeliveryResponseType['drm'];
        }) => void;
        close: () => void;
    };
}

declare global {
    interface Window {
        GeniusLivePlayer?: GeniusLivePlayerApiType;
    }
}

export const GENIUS_MESSAGE_BUS_EVENT = 'geniussportsmessagebus';

export const logGeniusPlayerError = (category: string, availability?: string): void => {
    console.error('GeniusLivePlayer', {
        category,
        availability: availability ?? null,
    });
};

export const resolveGeniusDevice = (deviceFromPlayer?: string): streaming.GeniusDeviceType => {
    const normalized = (deviceFromPlayer ?? '').toUpperCase();
    if (normalized === 'MOBILE' || normalized === 'TABLET' || normalized === 'DESKTOP' || normalized === 'OTT') {
        return normalized;
    }

    if (typeof window !== 'undefined' && window.innerWidth < 1024) {
        return 'MOBILE';
    }

    return 'DESKTOP';
};

export const resolveGeniusRegion = (regionFromPlayer?: string): string => {
    if (regionFromPlayer !== undefined && regionFromPlayer.length > 0) {
        return regionFromPlayer;
    }

    return 'GB';
};

export const resolveGeniusProtocol = (deliveryType?: string): streaming.GeniusDeliveryProtocolType | null => {
    const normalized = (deliveryType ?? '').toUpperCase();
    if (normalized === 'HLS' || normalized === 'DASH') {
        return normalized;
    }

    return null;
};
